import { createContext, useMemo, useRef, useState } from "react";
import type { Editor } from "grapesjs";
import type { PageBuilderCtx } from "../types/page-builder.types";

export const PageBuilderContext = createContext<PageBuilderCtx | null>(null);

interface PageBuilderProviderProps {
  children: React.ReactNode;
}

export function PageBuilderProvider({ children }: PageBuilderProviderProps) {
  // Editor context - SOLO COSAS DEL CORE O QUE REQUIERE LA LIBRERIA
  const editorRef = useRef<Editor | null>(null);
  const [isReady, setReady] = useState(false);
  const [isSaved, setIsSaved] = useState(true);

  const value = useMemo(
    () => ({
      editorRef,
      isReady,
      setReady,
      isSaved,
      setIsSaved,
    }),
    [isReady, isSaved],
  );

  return <PageBuilderContext.Provider value={value}>{children}</PageBuilderContext.Provider>;
}
